<div class="clearboth">
</div>
@if (object1 | async; as item) {
  <div class="PibannerUk">
    <a class="pibannerlink" href="/prescribinginformation">{{item.name}}
      <img alt="Next screen" src="../../../app/../assets/images/arrow-right-white.svg">
    </a>
  </div>
}



